import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import React from "react";
import {formatCurrency} from "../utils/formatters";

const LitsenziyaAdd = ({showModal, onHide, setShowModal, selectedItem, formData, setFormData, handleTransportInput, selectTransport, filteredTransports, handleSave,showCombo,setShowCombo, transportId   }) => {
    // const [showCombo, setShowCombo] = useState(false);


    const handleSummaChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setFormData(prev => ({
            ...prev,
            narx: value ? formatCurrency(parseInt(value)) : ''
        }));
    };

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered style={{zIndex: 2000}}>
            <Modal.Header
                closeButton><Modal.Title>{selectedItem ? 'Tahrirlash' : 'Qo‘shish'}</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form>
                    {!transportId && (
                        <Form.Group className="mb-3"><Form.Label>Transport raqami</Form.Label>
                            <Form.Control value={formData.transportNumber} onChange={handleTransportInput}
                                          onFocus={() => setShowCombo(true)}/>
                            {showCombo && filteredTransports.length > 0 && (
                                <div className="border bg-white position-absolute w-100 shadow-sm"
                                     style={{zIndex: 10, maxHeight: '180px', overflowY: 'auto'}}>
                                    {filteredTransports.map(t => {
                                        const isSelected = t.davlat_raqam === formData.transportNumber;
                                        return (
                                            <div
                                                key={t.id}
                                                className={`px-2 py-1 selectable-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => selectTransport(t.davlat_raqam, t.id)}
                                            >
                                                {t.davlat_raqam}
                                            </div>)
                                    })}
                                </div>
                            )}
                        </Form.Group>
                    )}
                    <Form.Group className="mb-3"><Form.Label>Litsenziya raqami</Form.Label>
                        <Form.Control value={formData.raqam}
                                      onChange={e => setFormData({...formData, raqam: e.target.value})}/>
                    </Form.Group>
                    <Row>
                        <Col><Form.Group className="mb-3"><Form.Label>Boshlanish sanasi</Form.Label>
                            <Form.Control type="date" value={formData.dan}
                                          onChange={e => setFormData({...formData, dan: e.target.value})}/></Form.Group></Col>
                        <Col><Form.Group className="mb-3"><Form.Label>Tugash sanasi</Form.Label>
                            <Form.Control type="date" value={formData.gacha} onChange={e => setFormData({
                                ...formData,
                                gacha: e.target.value
                            })}/></Form.Group></Col>
                    </Row>
                    <Form.Group className="mb-3"><Form.Label>Narx</Form.Label>
                        {/*<Form.Control type="number" value={formData.narx}*/}
                        {/*              onChange={e => setFormData({...formData, narx: e.target.value})}/>*/}
                        <Form.Control
                            type="text"
                            name="summa"
                            value={formData.narx}
                            onChange={handleSummaChange}
                            placeholder="0"
                            required
                            disabled={false}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3"><Form.Label>Izoh</Form.Label>
                        <Form.Control as="textarea" rows={2} value={formData.izoh}
                                      onChange={e => setFormData({...formData, izoh: e.target.value})}/></Form.Group>
                    <Form.Group className="mb-3"><Form.Label>Fayl</Form.Label>
                        <Form.Control type="file" onChange={e => setFormData({...formData, fayl: e.target.files[0]})}/></Form.Group>
                    <div className="text-end">
                        <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>Bekor
                            qilish</Button>
                        <Button variant="primary" onClick={handleSave}>Saqlash</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default LitsenziyaAdd